import { useHistory } from 'react-router'
import logo from '../eye-mask.svg'
import { appConfig } from '../models/constants'
import { rootStore } from '../StApp'

export const PublicProfileHeader = ()=>{

    const history = useHistory()



    return(
        <div className='flex-row center-align ' style={{ 
            justifyContent:'space-between', padding:'8px', height: 20, position: 'sticky', zIndex: 100, backgroundColor: '#fed4ff', top: 0}}  >
            <img src={logo} alt="" style={{ width: '50px', height: '30px' }} onClick={()=> history.push('/stapp/home')} />
            <p>{rootStore.mainStore.uid? appConfig.APP_NAME: null}</p>
            <p>{rootStore.mainStore.uid? rootStore.mainStore.userName: appConfig.APP_NAME}</p>
        </div>
    )
}